import React, { useCallback, useEffect, useRef, useState } from "react";
import SideBar from "../Sidebar/SideBar";
import { Icon } from "@iconify/react/dist/iconify.js";
import ModelssueRemarkList from "../Models/ModelssueRemarkList";
import SupportApi from "../../Api/Support";
import { useCookies } from "react-cookie";
import { jwtDecode } from "jwt-decode";
import Swal from "sweetalert2";
import AccountManager from "../../Api/AccountManager";
import Chatbot from "../Models/ChatbotModel";
import { onSseNotification } from "../../utils/notificationBus";

const Support = () => {
  const [totalUnread, setTotalUnread] = useState(0);

  const [rows, setRows] = useState(Array(10).fill({}));
  const [ticketData, setTicketData] = useState([]);
  const [tickets, setTickets] = useState(ticketData);
  const [cookies] = useCookies(["token"]);

  // Access the token from cookies
  const token = cookies.token;

  console.log("ticketData", ticketData);
  console.log("tickets", tickets);

  const lastInputRef = useRef(null);

  const handleKeyDown = (event) => {
    if (
      event.key === "Enter" &&
      document.activeElement === lastInputRef.current
    ) {
      event.preventDefault();
      setRows((prevRows) => [...prevRows, {}]);
    }
  };

  /***************************Model*************************** */

  const [isModalOpenTask, setIsModalOpenTask] = useState(false);
  const showModalTask = () => {
    setIsModalOpenTask(true);
  };

  const hideModalTask = () => {
    setIsModalOpenTask(false);
  };

  const handleRemarkUpdate = () => {
    hideModalTask();
  };

  const handleDelete = async (data) => {
    console.log("data", data);
    try {
      const response = await SupportApi.DeleteSupport(data.id);
      if (response.StatusCode === 200) {
        Swal.fire({
          title: "Deleted",
          text: "Deleted Successfully",
          icon: "success",
          width: "320px",
        });
        fetchData();
      } else {
        Swal.fire({
          title: "Failed",
          text: "Failed to delete ticket.",
          icon: "error",
          width: "320px",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  /******************************************* */

  const handleChange = (index, field, value) => {
    const updatedTickets = [...tickets];
    updatedTickets[index] = {
      ...updatedTickets[index],
      [field]: value,
    };
    setTickets(updatedTickets);
  };

  useEffect(() => {
    setTickets(ticketData);
  }, [ticketData]);

  const handleSave = async (ticket) => {
    console.log("ticket", ticket);

    const decoded = jwtDecode(token);

    const userId = decoded.id;
    const username = decoded.Username;

    const id = ticket.id;
    const data = {
      branchId: ticket.branchId,
      clientName: ticket.clientName,
      mobileNo: ticket.mobileNo,
      email: ticket.email,
      type: ticket.type,
      givenBy: ticket.givenBy,
      concernPerson: ticket.concernPerson,
      issueRemark: ticket.issueRemark,
      task: ticket.task,
      dateTime: ticket.dateTime,
      status: ticket.status,
      isClose: ticket.isClose,
      supporterRemark: ticket.supporterRemark,
      hash: ticket.hash,
      updatedBy: username,
      remarks: ticket.remarks != null ? ticket.remarks : null,
      supportMemberId: userId,
    };

    const response = await SupportApi.UpdateSupport(id, data);
    if (response) {
      console.log("response", response);
      Swal.fire({
        title: "Updated",
        text: "Updated Successfully",
        icon: "success",
        width: "320px",
      });
      fetchData();
    }
  };

  function getUniqueByHash(data) {
    const seen = new Set();
    return data.filter((item) => {
      if (item.hash && !seen.has(item.hash)) {
        seen.add(item.hash);
        return true;
      }
      return false;
    });
  }

  const fetchData = useCallback(async () => {
    const response = await SupportApi.GetAllSupport();

    if (response?.StatusCode === 200) {
      console.log("response", response);
      const supportMessages = response.Result || [];
      const unreadCount = supportMessages.reduce(
        (total, item) =>
          total +
          (item.issueRemark?.trim() && !(item.isRead ?? false) ? 1 : 0),
        0,
      );
      setTotalUnread(unreadCount);

      const uniqueTickets = getUniqueByHash(supportMessages);
      setTicketData(uniqueTickets);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    let refreshTimer;
    const unsubscribe = onSseNotification(() => {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(fetchData, 250);
    });

    return () => {
      clearTimeout(refreshTimer);
      unsubscribe();
    };
  }, [fetchData]);

  const [accountManager, setAccountManager] = useState();

  const fetchAccountManager = async () => {
    try {
      const data = await AccountManager.GetAllAccountManager();
      console.log("accountManager", data?.Result);
      setAccountManager(data?.Result);
    } catch (err) {
      console.log("Error", err);
    }
  };

  useEffect(() => {
    fetchAccountManager();
  }, []);

  const [openChatModel, setOpenChatModel] = useState(false);

  const openChatbot = () => {
    setOpenChatModel(true);
  };

  const closeChatbot = () => {
    setOpenChatModel(false);
  };

  useEffect(() => {
    document.body.classList.toggle("chatbot-open", openChatModel);
    return () => document.body.classList.remove("chatbot-open");
  }, [openChatModel]);

  return (
    <div className="Flex-general-client-sidebar">
      <div className="sidebar-gen-width">
        <SideBar />
      </div>
      <div className="Main-general-Client">
        <div className="header-general">
          <h2 className="general-card-title">Support</h2>
        </div>

        <div className="control_radius" onKeyDown={handleKeyDown}>
          <div
            className="table-support-manager"
            style={{ overflowX: "auto", width: "100%" }}
          >
            <table
              className="table-master-acc"
              style={{ minWidth: "max-content" }}
            >
              <thead className="header-table-account">
                <tr>
                  <th className="table-header-manager ac-sno-wth">S.No</th>
                  <th className="table-header-manager">Customer Name</th>
                  <th className="table-header-manager">Mobile No</th>
                  <th className="table-header-manager">Email</th>
                  <th className="table-header-manager">Type</th>
                  <th className="table-header-manager">Given By</th>
                  <th className="table-header-manager">Concern Person</th>
                  <th className="table-header-manager">Issue Remark</th>
                  {/* <th className='table-header-manager'>Task</th> */}
                  <th className="table-header-manager">Date</th>
                  <th className="table-header-manager">Time</th>
                  <th className="table-header-manager">Status</th>
                  <th className="table-header-manager">Is Close</th>
                  <th className="table-header-manager">Supporter Remark</th>
                  {/* <th className='table-header-manager'>Hash</th> */}
                  <th className="table-header-manager">Remarks</th>
                  <th className="table-header-manager">Actions</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map((item, index) => {
                  const utcDate = new Date(item.dateTime);
                  const options = {
                    timeZone: "Asia/Kolkata",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false,
                  };
                  const [dateStr, timeStr] = utcDate
                    .toLocaleString("en-IN", options)
                    .split(", ");

                  // Reformat date for input type='date'
                  const date = dateStr.split("/").reverse().join("-"); // YYYY-MM-DD format for date input
                  const time = timeStr;

                  return (
                    <tr key={index}>
                      <td className="table-data-account ac-sno-wth">
                        {index + 1}
                      </td>
                      <td className="table-data-account">
                        <label>{item.clientName}</label>
                      </td>
                      <td className="table-data-account">
                        <label>{item.mobileNo}</label>
                      </td>
                      <td className="table-data-account">
                        <label>{item.email}</label>
                      </td>
                      <td className="table-data-account">
                        <select
                          className="input-box-support"
                          value={item.type || ""}
                          onChange={(e) =>
                            handleChange(index, "type", e.target.value)
                          }
                        >
                          <option>-</option>
                          <option>By Call</option>
                          <option>By Chat</option>
                          <option>Visit</option>
                          <option>General</option>
                        </select>
                      </td>

                      {/* Given By */}
                      <td className="table-data-account">
                        <select
                          className="input-box-support"
                          value={item.givenBy || ""}
                          onChange={(e) =>
                            handleChange(index, "givenBy", e.target.value)
                          }
                        >
                          {accountManager &&
                            accountManager?.map((data, i) => (
                              <option key={i} value={data.id}>
                                {data.name}
                              </option>
                            ))}
                        </select>
                      </td>

                      {/* Concern Person */}
                      <td className="table-data-account">
                        <input
                          className="input-box-support"
                          type="text"
                          value={item.concernPerson || ""}
                          onChange={(e) =>
                            handleChange(index, "concernPerson", e.target.value)
                          }
                        />
                      </td>

                      {/* Issue Remark */}
                      <td className="table-data-account">
                        <div className="flex-support-add">
                          <textarea
                            value={item.issueRemark || ""}
                            onChange={(e) =>
                              handleChange(index, "issueRemark", e.target.value)
                            }
                            className="input-box-support-rmrk task-support"
                          />
                        </div>
                      </td>

                      {/* Task */}
                      {/* <td className='table-data-account'>
                                                <textarea
                                                    value={item.task || ''}
                                                    onChange={(e) => handleChange(index, 'task', e.target.value)}
                                                    className='input-box-support-rmrk task-support'
                                                />
                                            </td> */}

                      {/* Date */}
                      <td className="table-data-account">
                        <input
                          className="input-box-support"
                          value={date}
                          type="date"
                          readOnly
                        />
                      </td>

                      {/* Time */}
                      <td className="table-data-account">
                        <input
                          className="input-box-support"
                          value={time}
                          type="time"
                          readOnly
                        />
                      </td>

                      {/* Status */}
                      <td className="table-data-account">
                        <select
                          className="input-box-support"
                          value={item.status || ""}
                          onChange={(e) =>
                            handleChange(index, "status", e.target.value)
                          }
                        >
                          <option>Pending</option>
                          <option>Open</option>
                          <option>Closed</option>
                          <option>Unresolved</option>
                        </select>
                      </td>

                      {/* Is Close */}
                      <td className="table-data-account">
                        <input
                          type="checkbox"
                          checked={item.isClose || false}
                          onChange={(e) =>
                            handleChange(index, "isClose", e.target.checked)
                          }
                        />
                      </td>

                      {/* Supporter Remark */}
                      <td className="table-data-account">
                        <div className="flex-support-add">
                          <textarea
                            value={item.supporterRemark || ""}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "supporterRemark",
                                e.target.value,
                              )
                            }
                            className="input-box-support-rmrk task-support"
                          />
                          <div>
                            <Icon
                              icon="gridicons:add"
                              className="dm_4 plus_user"
                              onClick={showModalTask}
                            />
                          </div>
                        </div>
                        {isModalOpenTask && (
                          <div className="modal-task">
                            <div
                              className="OpticalField-modal Remark-List-model"
                              style={{
                                height: "auto",
                                maxWidth: "545px",
                                maxHeight: "600px",
                              }}
                            >
                              <div className="modal-title-Report">
                                <h3 className="Report-Fixed-Header">
                                  Remark List
                                </h3>
                                <span
                                  className="close_modal"
                                  onClick={hideModalTask}
                                >
                                  &times;
                                </span>
                              </div>
                              <div className="tab-content-modal">
                                <div className="company-info-top-modal control_flex_modal item_scroll">
                                  <span
                                    className="close_modal"
                                    onClick={hideModalTask}
                                  >
                                    &times;
                                  </span>
                                  <ModelssueRemarkList
                                    onClose={hideModalTask}
                                    onUpdate={handleRemarkUpdate}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </td>

                      {/* Hash*/}
                      {/* <td className='table-data-account'>
                                                <label>{item.hash}</label>
                                                <input disabled
                                                    className='input-box-support'
                                                    type='text'
                                                    value={item.hash || ''}
                                                //onChange={(e) => handleChange(index, 'hash', e.target.value)}
                                                />
                                            </td> */}

                      {/* Remarks */}
                      <td className="table-data-account">
                        <textarea
                          className="input-box-support-rmrk"
                          value={item.remarks || ""}
                          ref={index === rows.length - 1 ? lastInputRef : null}
                          onChange={(e) =>
                            handleChange(index, "remarks", e.target.value)
                          }
                        />
                      </td>

                      {/* Actions */}
                      <td className="table-data-account">
                        <button
                          className="save-btn-acc"
                          onClick={() => handleSave(tickets[index])}
                        >
                          <Icon icon="ion:save" />
                        </button>
                        <button className="edit-btn-acc">
                          <Icon icon="lucide:edit" />
                        </button>
                        <button
                          className="delete-btn-acc"
                          onClick={() => handleDelete(tickets[index])}
                        >
                          <Icon icon="material-symbols:delete" />
                        </button>
                        <button
                          className="delete-btn-acc"
                          onClick={openChatbot}
                        >
                          <Icon icon="token-branded:chat" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {!openChatModel && (
          <button
            className="chat-popup-fab"
            onClick={openChatbot}
            title="Open Messages"
          >
            <div className="fab-ring" />
            💬
            {totalUnread > 0 && <span className="fab-badge">{totalUnread}</span>}
          </button>
        )}
        {openChatModel && (
          <Chatbot
            closeChatbot={closeChatbot}
            setTotalUnread={setTotalUnread}
          />
        )}
      </div>
    </div>
  );
};

export default Support;
